import ApprovalBox from "./ApprovalBox";
import Box from "./Box";
import InstoreAddDetails from "./InstoreAddDetails";
import {
  NARROW,
  HOW,
  CHOOSE,
  ADD_DETAILS,
  ADD_RETURN_REASONS,
  LARGE,
} from "../core-modules/constants";

import React, { useEffect, useState } from "react";
import TakebackLayout from "./TakebackLayout";
import HoldingPageContent from "./HoldingPageContent";
import { theme } from "../core-modules/theme";
import { useRouter } from "next/router";
import { getBrandFonts } from "../core-modules/utils";
import { useBrand } from "./BrandContext";
import { useTakebackConfig } from "./TakebackConfigContext";
import { useAppContext } from "../components/AppContext";
import How from "./How";
import Choose from "./Choose";
import AddReturnReasons from "./AddReturnReasons";
import Progress from "./Progress";

function InstoreTakeback() {
  const router = useRouter();
  const { slug } = router.query;
  const [isContentVisible, setIsContentVisible] = useState(false);
  const { hasBrandFont, live, holdingPageContent } = useBrand();
  const { headerTextMain, headerTextSub, showSteps, addDetailsHeading } =
    useTakebackConfig();
  const { currentStep, setCurrentStep } = useAppContext();

  useEffect(() => {
    if (hasBrandFont) {
      const brandFonts = getBrandFonts(slug);
      if (brandFonts) {
        theme.fonts.main = brandFonts.main;
        theme.fonts.bold = brandFonts.bold;
      }
    }
    setIsContentVisible(true);
  }, [hasBrandFont, slug]);

  const headings = {
    how: {
      mainHeading: headerTextMain,
      subheading: headerTextSub,
    },
    choose: {
      mainHeading: "Let's put your pre-loved items to good use.",
      subheading: "",
    },
    addReturnReasons: {
      mainHeading: "Why are you recycling these items?",
      subheading: "",
    },
    addDetails: {
      mainHeading: addDetailsHeading || "Give old clothes a new home",
      subheading: "…and get rewards, through our takeback scheme.",
    },
  };

  let stepComponent;

  if (!live) {
    stepComponent = <HoldingPageContent content={holdingPageContent} />;
  } else {
    if (currentStep === HOW)
      stepComponent = <How setCurrentStep={setCurrentStep} />;
    if (currentStep === CHOOSE) stepComponent = <Choose embedMode={false} />;
    if (currentStep === ADD_RETURN_REASONS)
      stepComponent = <AddReturnReasons />;
    if (currentStep === ADD_DETAILS)
      stepComponent = <InstoreAddDetails setCurrentStep={setCurrentStep} />;
  }

  if (!isContentVisible) {
    return null;
  }

  return (
    <>
      <ApprovalBox />
      <TakebackLayout
        embedMode={false}
        headings={headings[currentStep]}
        size={currentStep === HOW ? LARGE : NARROW}
        title="Reskinned | Takeback"
      >
        {live && showSteps && <Progress />}
        <Box pt={[50, null, 80, null]}>{stepComponent}</Box>
      </TakebackLayout>
    </>
  );
}

export default InstoreTakeback;
